export default function SearchIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_1501_1390"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.5291 9.81997H10.8336L10.5872 9.58229C11.4499 8.57875 11.9692 7.27591 11.9692 5.85864C11.9692 2.69838 9.40757 0.136719 6.24731 0.136719C3.08705 0.136719 0.525391 2.69838 0.525391 5.85864C0.525391 9.0189 3.08705 11.5806 6.24731 11.5806C7.66459 11.5806 8.96742 11.0612 9.97096 10.1985L10.2086 10.445V11.1404L14.6101 15.5331L15.9218 14.2214L11.5291 9.81997ZM6.24667 9.81962C4.05474 9.81962 2.28534 8.05023 2.28534 5.85829C2.28534 3.66635 4.05474 1.89696 6.24667 1.89696C8.43861 1.89696 10.208 3.66635 10.208 5.85829C10.208 8.05023 8.43861 9.81962 6.24667 9.81962Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_1501_1390)">
        <rect
          x="-14"
          y="-14.3882"
          width="43.5746"
          height="43.5746"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}
